import type { RaceFinishedEvent } from "@/types/Racing/RaceFinishedEvent";

const STORAGE_KEY = "lastRaceResult";

export const isPlayersRace = (account: string, event: RaceFinishedEvent) => {
  const player = account.toLowerCase();
  return !!player && (
    event.creator?.toLowerCase() === player ||
    event.opponent?.toLowerCase() === player
  );
};

export const hasValidRaceId = (event: RaceFinishedEvent) =>
  Number.isSafeInteger(event.raceId) && event.raceId >= 0;

export const saveRaceResult = (account: string, event: RaceFinishedEvent) => {
  if (!isPlayersRace(account, event) || !hasValidRaceId(event)) return;
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(event));
  } catch {
    // Router state still carries the result when session storage is unavailable.
  }
};

export const readRaceResult = (account: string, raceId: number): RaceFinishedEvent | null => {
  try {
    const saved = sessionStorage.getItem(STORAGE_KEY);
    if (!saved) return null;
    const event = JSON.parse(saved) as RaceFinishedEvent;
    return event?.raceId === raceId && isPlayersRace(account, event) ? event : null;
  } catch {
    return null;
  }
};
